<template>
  <div class="issueadd" v-dragDiv v-show="addShow">
    <div class="addTitle moveDragDiv">
      <span>属性</span>
      <i class="el-icon-close" @click="closeArea"></i>
    </div>
    <div class="nav">
      <el-tree :data="treedatas" :props="defaultProps" class="attrtree" empty-text="请点击选择构件" >
        <span class="custom-tree-node" slot-scope="{ node }" :title="node.label">
          <span>{{ node.label }}</span>
        </span>
      </el-tree>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data(){
    return{
      addShow:false,
      modelInfos: "",
      treedatas: [],
      defaultProps: {
        children: "children",
        label: "label"
      }
    }
  },
  computed: {
    ...mapState({
      modelProperty: state => state.monge.modelProperty
    })
  },
  watch: {
    modelProperty(val, oldval) {
      this.getArtifactsTree(val);
    }
  },
  methods:{
    openArea(){
      this.addShow = true
    },
    closeArea(){
      this.addShow = false
    },
    getArtifactsTree(tree) {
      let treedata = [];
      let arr = "";
      let children = [];
      for (let i = 0; i < tree.length; i++) {
        let str = tree[i].name + "：" + tree[i].value;
        let child = { label: str };
        if (tree[i].group == arr) {
          children.push(child);
          if (tree.length - 1 == i) {
            treedata.push({
              label: arr,
              children: children.concat([])
            });
          }
        } else {
          if (i == 0) {
            arr = tree[i].group;
            children.push(child);
          } else {
            treedata.push({
              label: arr,
              children: children.concat([])
            });
            children = [];
            arr = tree[i].group;
            children.push(child);
          }
        }
      }
      this.treedatas = treedata.slice(2);
      if (treedata.length > 0) {
        for (let i = 0; i < this.treedatas.length; i++) {
          if (this.treedatas[i].label == "其他") {
            this.treedatas[i].label = "基本信息";
            let a = this.treedatas[0];
            this.treedatas[0] = this.treedatas[i];
            this.treedatas[i] = a;
            break;
          }
        }
      }
      // console.log(this.treedatas);
    },

  }
}
</script>

<style lang="scss" scoped>
.issueadd{
  position: absolute;
  top: 65px;
  left: 151px;
  width: 280px;
  height: calc(100% - 190px);
  max-height: 770px;
  z-index: 5;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0px 0px 4px 1px rgba(46, 91, 255, 0.17);
  border-radius: 4px;
  .addTitle{
    cursor: move;
    width: 100%;
    height: 50px;
    padding: 0 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #E8EBEF;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    span{
      font-size: 16px;
      font-weight: bold;
    }
    i{
      font-size: 16px;
      cursor: pointer;
    }
  }
  .nav{
    width: 100%;
    height: calc(100% - 50px);
    padding: 10px 0 10px 15px;
    overflow: hidden;
    overflow-y: auto;
    .attrtree {
      width: 100%;
      padding-right: 10px;
      .custom-tree-node{
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px !important;
      }
    }
    .el-tree-node__content {
      cursor: Default !important;
    }
  }
}
</style>